// @ts-ignore
import React from "react";
// @ts-ignore
import styles from "./channel-prompt-modal.module.scss";

interface ChannelPromptModalProps {
  onChatSelected: () => void;
  onSmsSelected: () => void;
  brandLogo: string;
}

export const ChannelPromptModal = ({
  onChatSelected,
  onSmsSelected,
  brandLogo,
}) => {
  return (
    <>
      <div className={styles.channel_backdrop} />
      <div className={styles.channel_modal_overlay}>
        <div className={styles.channel_modal}>
          <div className={styles.logo_container}>
            <img src={brandLogo} alt="Brand Logo" />
          </div>
          <h2 className={styles.channel_title}>
            How would you like to connect?
          </h2>
          <p className={styles.channel_subtitle}>
            Choose your preferred way to get help
          </p>

          <div className={styles.channel_actions}>
            <button
              type="button"
              className={styles.channel_button}
              onClick={onChatSelected}
            >
              <span className={styles.button_icon}>🌐</span>
              <div className={styles.button_content}>
                <span className={styles.button_title}>Web</span>
                <span className={styles.button_subtitle}>Explore Here</span>
              </div>
            </button>

            <button
              type="button"
              className={`${styles.channel_button} ${styles.sms_button}`}
              onClick={onSmsSelected}
            >
              <span className={styles.button_icon}>📱</span>
              <div className={styles.button_content}>
                <span className={styles.button_title}>Text Message</span>
                <span className={styles.button_subtitle}>Get help via SMS</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
